module.exports = {
  BulletsData: () => {
    return {
      "avatr7" : {
        "external" :
          [
            // {
            //   "id" : "avatr7-RINES DE ACABADO BITONO",
            //   "title": "RINES DE ACABADO BITONO",
            //   "text": "Rines de 21 pulgadas Arc Phantom cinco radios y acabado bitono.",
            //   "image": require('../assets/bullets/001-sport/001-sport_002.webp'),
            //   "active": true,
            //   "position": {
            //     x: 1.09,
            //     y: 0.452,
            //     z: 1.789
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 39.17,
            //     distance: 5,
            //   }
            // },
            // {
            //   "id" : "avatr7-LUCES TRASERAS INTEGRADAS",
            //   "title": "LUCES TRASERAS INTEGRADAS",
            //   "text": "Las luces traseras integradas de 1,47 m de ancho forjan una apariencia fuerte y elegante, realzando el atractivo estético único del ZEEKR 001.",
            //   "image": require('../assets/bullets/001-sport/001-sport_001.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.506,
            //     y: 1.047,
            //     z: -2.492
            //   },
            //   "camera": {
            //     pitch: -14.2,
            //     yaw: 161.15,
            //     distance: 4.8,
            //   }
            // },
            // {
            //   "id" : "avatr7-LUCES MATRIX LED INTELIGENTES FAROS DE PROYECCIÓN",
            //   "title": "LUCES MATRIX LED INTELIGENTES FAROS DE PROYECCIÓN",
            //   "text": "Equipado con luz de carretera adaptativa ADB, 64 LED controlados de forma independiente ajustan dinámicamente la matriz de la luz de carretera, proporcionando una experiencia de conducción segura por la noche.",
            //   "image": "",
            //   "active": true,
            //   "position": {
            //     x: 0.772,
            //     y: 1.068,
            //     z: 1.982
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 18.05,
            //     distance: 4.64,
            //   }
            // },
            // {
            //   "id" : "avatr7-COEFICIENTE DE ARRASTRE ULTRA BAJO DE 0.23CD",
            //   "title": "COEFICIENTE DE ARRASTRE ULTRA BAJO DE 0.23CD",
            //   "text": "Perfeccionado en más de 1.000 simulaciones, su diseño aerodinámico logra el equilibrio ideal entre estética deportiva, actitud agresiva y eficiencia excepcional.",
            //   "image": require('../assets/bullets/001-sport/001-sport_008.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: 0.354,
            //     z: 2.578
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 0.1,
            //     distance: 5,
            //   }
            // },
            // {
            //   "id" : "avatr7-PUERTAS DEPORTIVAS SIN MARCO",
            //   "title": "PUERTAS DEPORTIVAS SIN MARCO",
            //   "text": "4 Puertas deportivas sin marco, cubiertas de exquisitos detalles llenos de lujo.",
            //   "image": require('../assets/bullets/001-sport/001-sport_009.webp'),
            //   "active": true,
            //   "position": {
            //     x: 1.079,
            //     y: 0.937,
            //     z: 0.074
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 87.65,
            //     distance: 3.86,
            //   }
            // },
            // {
            //   "id" : "avatr7-MALETERO DE 2144 L",
            //   "title": "MALETERO DE 2144 L",
            //   "text": "Inspirado en la maleta multifuncional de un viajero, el baúl puede ampliarse hasta 2144L. Se puede dividir fácilmente, lo que te permite utilizarlo como quieras.",
            //   "image": "",
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: 0.776,
            //     z: -2.579
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 179,
            //     distance: 4,
            //   }
            // },
          ],
        "internal" : 
          [
            // {
            //   "id" : "avatr7-Techo panorámico de cristal con filtro UV",
            //   "title": "Techo panorámico de cristal con filtro UV",
            //   "text": "",
            //   "image": require('../assets/bullets/001-sport/001-sport_006.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: 1.0,
            //     z: 0.127
            //   },
            //   "camera": {
            //     pitch: 85.5,
            //     yaw: -181.8,
            //     distance: 0.01,
            //   }
            // },
            // {
            //   "id" : "avatr7-Iluminación ambiental multicolor",
            //   "title": "Iluminación ambiental multicolor",
            //   "text": "El color y el brillo de las luces de ambiente delanteras y traseras se pueden ajustar de forma independiente, lo que le permite personalizar la iluminación de su espacio.",
            //   "image": require('../assets/bullets/001-sport/001-sport_004.webp'),
            //   "active": true,
            //   "position": {
            //     x: -0.626,
            //     y: -0.375,
            //     z: 1.262
            //   },
            //   "camera": {
            //     pitch: -16.8,
            //     yaw: -206.1,
            //     distance: 0.01,
            //   }
            // },
            // {
            //   "id" : "avatr7-AUDIO PREMIUM YAMAHA SURROUND",
            //   "title": "AUDIO PREMIUM YAMAHA SURROUND",
            //   "text": "Audio Yamaha con 11 bocinas de alta fidelidad y 1 subwoofer.",
            //   "image": require('../assets/bullets/001-sport/001-sport_007.webp'),
            //   "active": true,
            //   "position": {
            //     x: -1.252,
            //     y: -0.432,
            //     z: 1.262
            //   },
            //   "camera": {
            //     pitch: -18.89,
            //     yaw: -215.7,
            //     distance: 0.01,
            //   }
            // },
            // {
            //   "id" : "avatr7-CHIPS QUALCOMM SNAPDRAGON 8155",
            //   "title": "CHIPS QUALCOMM SNAPDRAGON 8155",
            //   "text": "Con procesadores de 7nm, 16 GB de memoria y 128 GB de almacenamiento de alta velocidad para una experiencia de usuario fluida.",
            //   "image": require('../assets/bullets/001-sport/001-sport_005.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: -0.687,
            //     z: 1.452
            //   },
            //   "camera": {
            //     pitch: -27.9,
            //     yaw: -177,
            //     distance: 0.01,
            //   }
            // },
            // {
            //   "id" : "avatr7-PANTALLA CENTRAL",
            //   "title": "PANTALLA CENTRAL",
            //   "text": "Pantalla central nítida de 15,4”, cuadro de instrumentos estilizado de 8,9”, con head-up display.",
            //   "image": require('../assets/bullets/001-sport/001-sport_004.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: 0.055,
            //     z: 1.452
            //   },
            //   "camera": {
            //     pitch: -0.299,
            //     yaw: -178.5,
            //     distance: 0.01,
            //   }
            // },
          ],
      },
      "avatr11" : {
        "external" :
          [
            // {
            //   "id" : "avatr7-RINES DE ACABADO BITONO",
            //   "title": "RINES DE ACABADO BITONO",
            //   "text": "Rines de 21 pulgadas Arc Phantom cinco radios y acabado bitono.",
            //   "image": require('../assets/bullets/001-sport/001-sport_002.webp'),
            //   "active": true,
            //   "position": {
            //     x: 1.09,
            //     y: 0.452,
            //     z: 1.789
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 39.17,
            //     distance: 5,
            //   }
            // },
            // {
            //   "id" : "avatr7-LUCES TRASERAS INTEGRADAS",
            //   "title": "LUCES TRASERAS INTEGRADAS",
            //   "text": "Las luces traseras integradas de 1,47 m de ancho forjan una apariencia fuerte y elegante, realzando el atractivo estético único del ZEEKR 001.",
            //   "image": require('../assets/bullets/001-sport/001-sport_001.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.506,
            //     y: 1.047,
            //     z: -2.492
            //   },
            //   "camera": {
            //     pitch: -14.2,
            //     yaw: 161.15,
            //     distance: 4.8,
            //   }
            // },
            // {
            //   "id" : "avatr7-LUCES MATRIX LED INTELIGENTES FAROS DE PROYECCIÓN",
            //   "title": "LUCES MATRIX LED INTELIGENTES FAROS DE PROYECCIÓN",
            //   "text": "Equipado con luz de carretera adaptativa ADB, 64 LED controlados de forma independiente ajustan dinámicamente la matriz de la luz de carretera, proporcionando una experiencia de conducción segura por la noche.",
            //   "image": "",
            //   "active": true,
            //   "position": {
            //     x: 0.772,
            //     y: 1.068,
            //     z: 1.982
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 18.05,
            //     distance: 4.64,
            //   }
            // },
            // {
            //   "id" : "avatr7-COEFICIENTE DE ARRASTRE ULTRA BAJO DE 0.23CD",
            //   "title": "COEFICIENTE DE ARRASTRE ULTRA BAJO DE 0.23CD",
            //   "text": "Perfeccionado en más de 1.000 simulaciones, su diseño aerodinámico logra el equilibrio ideal entre estética deportiva, actitud agresiva y eficiencia excepcional.",
            //   "image": require('../assets/bullets/001-sport/001-sport_008.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: 0.354,
            //     z: 2.578
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 0.1,
            //     distance: 5,
            //   }
            // },
            // {
            //   "id" : "avatr7-PUERTAS DEPORTIVAS SIN MARCO",
            //   "title": "PUERTAS DEPORTIVAS SIN MARCO",
            //   "text": "4 Puertas deportivas sin marco, cubiertas de exquisitos detalles llenos de lujo.",
            //   "image": require('../assets/bullets/001-sport/001-sport_009.webp'),
            //   "active": true,
            //   "position": {
            //     x: 1.079,
            //     y: 0.937,
            //     z: 0.074
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 87.65,
            //     distance: 3.86,
            //   }
            // },
            // {
            //   "id" : "avatr7-MALETERO DE 2144 L",
            //   "title": "MALETERO DE 2144 L",
            //   "text": "Inspirado en la maleta multifuncional de un viajero, el baúl puede ampliarse hasta 2144L. Se puede dividir fácilmente, lo que te permite utilizarlo como quieras.",
            //   "image": "",
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: 0.776,
            //     z: -2.579
            //   },
            //   "camera": {
            //     pitch: -10,
            //     yaw: 179,
            //     distance: 4,
            //   }
            // },
          ],
        "internal" : 
          [
            // {
            //   "id" : "avatr7-Techo panorámico de cristal con filtro UV",
            //   "title": "Techo panorámico de cristal con filtro UV",
            //   "text": "",
            //   "image": require('../assets/bullets/001-sport/001-sport_006.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: 1.0,
            //     z: 0.127
            //   },
            //   "camera": {
            //     pitch: 85.5,
            //     yaw: -181.8,
            //     distance: 0.01,
            //   }
            // },
            // {
            //   "id" : "avatr7-Iluminación ambiental multicolor",
            //   "title": "Iluminación ambiental multicolor",
            //   "text": "El color y el brillo de las luces de ambiente delanteras y traseras se pueden ajustar de forma independiente, lo que le permite personalizar la iluminación de su espacio.",
            //   "image": require('../assets/bullets/001-sport/001-sport_004.webp'),
            //   "active": true,
            //   "position": {
            //     x: -0.626,
            //     y: -0.375,
            //     z: 1.262
            //   },
            //   "camera": {
            //     pitch: -16.8,
            //     yaw: -206.1,
            //     distance: 0.01,
            //   }
            // },
            // {
            //   "id" : "avatr7-AUDIO PREMIUM YAMAHA SURROUND",
            //   "title": "AUDIO PREMIUM YAMAHA SURROUND",
            //   "text": "Audio Yamaha con 11 bocinas de alta fidelidad y 1 subwoofer.",
            //   "image": require('../assets/bullets/001-sport/001-sport_007.webp'),
            //   "active": true,
            //   "position": {
            //     x: -1.252,
            //     y: -0.432,
            //     z: 1.262
            //   },
            //   "camera": {
            //     pitch: -18.89,
            //     yaw: -215.7,
            //     distance: 0.01,
            //   }
            // },
            // {
            //   "id" : "avatr7-CHIPS QUALCOMM SNAPDRAGON 8155",
            //   "title": "CHIPS QUALCOMM SNAPDRAGON 8155",
            //   "text": "Con procesadores de 7nm, 16 GB de memoria y 128 GB de almacenamiento de alta velocidad para una experiencia de usuario fluida.",
            //   "image": require('../assets/bullets/001-sport/001-sport_005.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: -0.687,
            //     z: 1.452
            //   },
            //   "camera": {
            //     pitch: -27.9,
            //     yaw: -177,
            //     distance: 0.01,
            //   }
            // },
            // {
            //   "id" : "avatr7-PANTALLA CENTRAL",
            //   "title": "PANTALLA CENTRAL",
            //   "text": "Pantalla central nítida de 15,4”, cuadro de instrumentos estilizado de 8,9”, con head-up display.",
            //   "image": require('../assets/bullets/001-sport/001-sport_004.webp'),
            //   "active": true,
            //   "position": {
            //     x: 0.0,
            //     y: 0.055,
            //     z: 1.452
            //   },
            //   "camera": {
            //     pitch: -0.299,
            //     yaw: -178.5,
            //     distance: 0.01,
            //   }
            // },
          ],
      }
    }
  }
}